import React from 'react';

const CTA = () => {
  return (
    <section className="cta_wrap">
      <div className="cta_contain">
        <h2 className="cta_heading_sr u-sr-only">Ready to design your next inspired space?</h2>
        <h2 aria-hidden={true} data-lines-split="" data-animate-scroll="" className="cta_heading u-text-display">
          영감을 주는 공간, 집의 편안함을 담아냅니다.
        </h2>
        <h2 aria-hidden={true} data-lines-split="" data-animate-scroll="" className="cta_heading u-text-display u-tablet">
          영감을 주는 공간, 집의 편안함을 담아냅니다.
        </h2>
      </div>
      <div className="cta_button_wrap">
        <button data-wf--btn-contact--variant="base" data-contact-btn="" className="btn_default_wrap">
          <div className="btn_default_contain">
            <div data-link="" className="btn_default_text">상담신청</div>
          </div>
          <div className="g_circle is-light"></div>
        </button>
      </div>
    </section>
  );
};

export default CTA;